<template>
  <v-dialog ref="dialog1" v-model="dialog" max-width="290">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        style="border: none"
        width="242"
        color="#4f78e2"
        v-bind="attrs"
        v-on="on"
      >
        <span style="color: white">
          {{ model === "" ? label : model }}
        </span>
        <v-icon color="#fff" right> schedule </v-icon>
      </v-btn>
    </template>

    <v-time-picker
      v-on:click:hour="clickHoursEvent"
      v-model="model"
      :allowed-hours="allowedHours"
      :allowed-minutes="allowedMinutes"
      v-on:click:minute="Close()"
      header-color="#4f78e2"
      format="24hr"
    ></v-time-picker>
  </v-dialog>
</template>

<script>
export default {
  mounted() {
    if (this.type === "start") {
      this.model =
        `${this.original.startHour.hour}:${this.original.startHour.mint}` ===
        "-1:-1"
          ? ""
          : `${this.original.startHour.hour}:${this.original.startHour.mint}`;
    } else {
      this.model =
        `${this.original.endHour.hour}:${this.original.endHour.mint}` ===
        "-1:-1"
          ? ""
          : `${this.original.endHour.hour}:${this.original.endHour.mint}`;
    }
  },
  props: {
    label: { type: String },
    type: { type: String },
    original: { type: Object },
    onChange: { type: Function }
  },
  data() {
    return {
      dialog: false,
      model: "",
      hour: ""
    };
  },
  watch: {
    original(newV, oldV) {}
  },
  methods: {
    clickHoursEvent(hour) {
      this.hour = hour;
    },
    allowedHours(v) {
      if (this.type == "end" && Number(this.original.startHour.hour) > -1) {
        if (v < Number(this.original.startHour.hour)) {
          return false;
        }
      }
      if (this.type == "start" && Number(this.original.endHour.hour) > -1) {
        if (v > Number(this.original.endHour.hour)) {
          return false;
        }
      }
      if (v >= 0) return true;
      return false;
    },
    allowedMinutes(v) {
      if (
        this.type == "end" &&
        Number(this.original.startHour.mint) > -1 &&
        this.hour == this.original.startHour.hour
      ) {
        if (v < Number(this.original.startHour.mint)) {
          return false;
        }
      }
      if (
        this.type == "start" &&
        Number(this.original.endHour.mint) > -1 &&
        this.hour == this.original.endHour.hour
      ) {
        if (v > Number(this.original.endHour.mint)) {
          return false;
        }
      }
      return true;
    },
    Close() {
      this.onChange(this.original, this.model);
      this.dialog = false;
    }
  }
};
</script>

<style></style>
